import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CoreService } from 'src/app/common';
import { environment } from 'src/environments/environment';
import { SeoUsageSummaryResponse } from './seo-usage.models';

@Injectable({
  providedIn: 'root'
})
export class SeoUsageApiService {
  private readonly baseUrl: string = `${(environment as any).identityServiceUrl ?? environment.identityUrl}/auditlog`;

  public constructor(private readonly core: CoreService<SeoUsageSummaryResponse>) {}

  public getSeoUsageSummary(organizationId: number, from?: string, to?: string, service?: string): Observable<SeoUsageSummaryResponse> {
    const url: string = this.buildUrl(organizationId, from, to, service);

    return this.core
      .get(url)
      .pipe(map((response: SeoUsageSummaryResponse) => this.normalizeResponse(response, organizationId, from, to)));
  }

  private buildUrl(organizationId: number, from?: string, to?: string, service?: string): string {
    const baseEndpoint: string = `${this.baseUrl}/organizations/${organizationId}/seo-usage`;
    const queryParts: string[] = [];

    if (from) {
      queryParts.push(`from=${encodeURIComponent(from)}`);
    }

    if (to) {
      queryParts.push(`to=${encodeURIComponent(to)}`);
    }

    if (service) {
      queryParts.push(`service=${encodeURIComponent(service)}`);
    }

    if (!queryParts.length) {
      return baseEndpoint;
    }

    return `${baseEndpoint}?${queryParts.join('&')}`;
  }

  private normalizeResponse(
    response: SeoUsageSummaryResponse | null | undefined,
    organizationId: number,
    from?: string,
    to?: string
  ): SeoUsageSummaryResponse {
    return {
      organizationId: response?.organizationId ?? organizationId,
      from: response?.from ?? from,
      to: response?.to ?? to,
      requestCount: response?.requestCount ?? 0,
      totalCost: response?.totalCost ?? 0,
      totalItemsCount: response?.totalItemsCount ?? 0,
      totalResultCount: response?.totalResultCount ?? 0,
      sources: response?.sources ?? [],
      timeline: response?.timeline ?? []
    };
  }
}
